import React, { useState } from 'react';
import { Dialog, Spinner, T } from '@colonist/ui';
import { RegionChangeForm } from './RegionChangeForm/RegionChangeForm.tsx';
import styles from './ChangeRegionDialog.module.scss';
const EMPTY_SELECTION = {
    continentCode: '',
    countryCode: '',
    regionCode: ''
};
export const ChangeRegionDialog = ({ open, loading, regions, initialSelection, onCancel, onSubmit })=>{
    const [selection, setSelection] = useState(initialSelection !== null && initialSelection !== void 0 ? initialSelection : EMPTY_SELECTION);
    const canConfirm = !loading && selection.continentCode.trim() !== '';
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: onCancel
    }, /*#__PURE__*/ React.createElement(Dialog.Title, null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:popups.changeRegion.title'
        }
    })), /*#__PURE__*/ React.createElement(Dialog.Content, null, loading ? /*#__PURE__*/ React.createElement("div", {
        className: styles.loadingContainer
    }, /*#__PURE__*/ React.createElement(Spinner, {
        className: styles.spinner
    })) : /*#__PURE__*/ React.createElement(RegionChangeForm, {
        regions: regions,
        selection: selection,
        onSelectionChange: setSelection
    })), /*#__PURE__*/ React.createElement(Dialog.ButtonFooter, null, /*#__PURE__*/ React.createElement(Dialog.ButtonFooter.CancelButton, {
        onClick: onCancel
    }), /*#__PURE__*/ React.createElement(Dialog.ButtonFooter.ConfirmButton, {
        disabled: !canConfirm,
        onClick: ()=>onSubmit(selection)
    })));
};
